import {PageViewTracker} from 'core/components/google-analytics';
import {FC} from 'react';
import {useUser} from 'contexts/user';

export const PageViewTrackerWithUserId: FC = () => {
    const {user} = useUser();
    return <PageViewTracker userId={user?.id} />;
};
